var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Bar',{staticClass:"BarCapacity",attrs:{"hasLabels":true,"max":_vm.project.capacity,"parts":_vm.parts}})}
var staticRenderFns = []

export { render, staticRenderFns }